// Backend (`/sound/decode`) sends the waveform as a Uint8Array (each bar normalized
// to 0..255) base64-encoded into `peaks.data`. Reverse that: base64 -> bytes -> 0..1
// floats, matching the Float32Array [0,1] shape the worker produces and WaveSurfer renders.
export const decodeUploadedPeaks = (data: string): Float32Array => {
  const binary = atob(data)
  const { length } = binary
  const peaks = new Float32Array(length)
  for (let i = 0; i < length; i++) {
    peaks[i] = binary.charCodeAt(i) / 255
  }
  return peaks
}

// Web Audio decode runs on the main thread; long files freeze low-RAM tabs.
// Cap by duration tier (deviceMemory rounded to nearest power of 2 by spec —
// undisclosed on Firefox/Safari, treated as the conservative tier).
// p.s. no matter if device has 8 or more ram, the returned max value is 8
export const getLimitsPerDevice = (): {
  sizeLimit: number
  durationLimit: number
} => {
  const memGB = (navigator as Navigator & { deviceMemory?: number })
    .deviceMemory
  if (memGB === undefined)
    return { durationLimit: 15 * 60, sizeLimit: 15 * 1024 * 1024 }
  if (memGB <= 4) return { durationLimit: 15 * 60, sizeLimit: 15 * 1024 * 1024 }
  if (memGB <= 6) return { durationLimit: 20 * 60, sizeLimit: 30 * 1024 * 1024 }
  return { durationLimit: 30 * 60, sizeLimit: 50 * 1024 * 1024 }
}
